export const generationsLevelOptions = [
    { value: "0", text: "ลูก" },
    { value: "1", text: "หลาน" },
    { value: "2", text: "เหลน" },
    { value: "3", text: "โหลน" },
    { value: "4", text: "ลื้อ" },
  ];
